import React from 'react';
import CheckEmpty from '../CheckEmpty';
import Check from '../Check';

function Question({ order, title, questions = [], selectedValue = [], setSelectedValue, additionalFieldAllowed = false, additionalFieldValue = '', setAdditionalField }) {
	// Ensure selectedValue is always an array
	const safeSelectedValue = Array.isArray(selectedValue) ? selectedValue : [];

	const handleOptionClick = (option) => {
		if (typeof setSelectedValue === 'function') {
			setSelectedValue(option);
		} else {
			console.error('setSelectedValue is not a function');
		}
	};

	const handleAdditionalFieldChange = (e) => {
		if (typeof setAdditionalField === 'function') {
			setAdditionalField(e.target.value);

			// If the additionalField has content (not empty or just spaces),
			// add a special "OTHER" option to selectedValue if it's not already there
			if (e.target.value.trim()) {
				// Create a custom "Other" option that will be used in the selected values
				const otherOption = 'OTHER_CUSTOM_VALUE';

				// Only add it if it's not already in the selectedValue array
				if (!safeSelectedValue.includes(otherOption)) {
					handleOptionClick(otherOption);
				}
			} else {
				// If the field is emptied, we should remove the OTHER option from selectedValue
				// This assumes that setSelectedValue can handle removing an option
				const otherOption = 'OTHER_CUSTOM_VALUE';
				if (safeSelectedValue.includes(otherOption)) {
					// We need to remove this option from the selectedValue
					// This depends on how your Survey component handles removal
					handleOptionClick(otherOption); // This should toggle it off
				}
			}
		} else {
			console.error('setAdditionalField is not a function');
		}
	};

	return (
		<div>
			<p className='text-2xl font-bold'>
				{order}. {title}
			</p>
			<div className='flex flex-col gap-[5px] mt-[10px]'>
				{questions && questions.length > 0 ? (
					questions.map((option, index) => (
						<button type='button' className='flex flex-row items-start gap-[5px] w-full text-left py-2' key={index} onClick={() => handleOptionClick(option)}>
							<div className='flex-shrink-0 mt-1 mr-2'>{safeSelectedValue.includes(option) ? <Check /> : <CheckEmpty />}</div>
							<p className='flex-1'>{option}</p>
						</button>
					))
				) : (
					<p>No options available</p>
				)}
				{additionalFieldAllowed && (
					<div className='flex flex-row items-center gap-[10px] mt-[10px]'>
						<div className='flex items-center gap-[5px]'>
							{safeSelectedValue.includes('OTHER_CUSTOM_VALUE') ? <Check /> : <CheckEmpty />}
							<p>Other (please specify):</p>
						</div>
						<input className='border-b px-2 py-1 flex-1' value={additionalFieldValue || ''} onChange={handleAdditionalFieldChange} placeholder='Enter details here' />
					</div>
				)}
			</div>
			<p>&nbsp;</p>
		</div>
	);
}

export default Question;
